export default __webpack_public_path__ + "13b5a31bebd2cc6016d6db2cac8e92d1.svg";